module.exports = __webpack_public_path__ + "static/media/cssIcon.7430105b.svg";